import Commons from '../../../Services/Common/Common';

export const M_EIS_BASIC_Schema = {
  fields: {},
  mapper: {
    /** 사업장 관리자 정보 조회 GetCustManager (SP_GET_AUTH_CUST_MANAGER) */
    search1: {
      UserId: (context) => context.userInfo?.userid ?? '',
      AuthCd: (context) => Commons.EncryptAES(context.userInfo?.authCd) || '',
    },
    /** 보호구 수령현황 조회 GetEisBasicR1 (SP_M_EIS_BASIC_R1) */
    search2: {
      DateFrom: (context) => Commons.EncryptAES(context.dateFrom ?? '') || '',
      DateTo: (context) => Commons.EncryptAES(context.dateTo ?? '') || '',
      CustCd: (context) => Commons.EncryptAES(context.custCd ?? '') || '',
      UserId: (context) => context.userInfo?.userid ?? '',
    },
    /** 보호구 지급 서명 저장 SaveEisBasicU1 (SP_M_EIS_BASIC_U1) */
    save1: {
      IssuId: (row) => Commons.EncryptAES(row.issuId?.toString() ?? '') || '',
      IssuSignPath: (row) => Commons.EncryptAES(row.issuSignPath ?? '') || '',
      UserId: (_, context) => context.userInfo?.userid ?? '',
    },
  },
};
